// removed by extract-text-webpack-plugin
module.exports = {"layout":"DesktopLayout__layout--2272R"};


//////////////////
// WEBPACK FOOTER
// ./src/app/Layout/DesktopLayout/DesktopLayout.css
// module id = uAuo
// module chunks = 0